import React from 'react';
import { Settings, Zap, Battery } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';

interface SolutionSettingsCardProps {
  contractedCapacity: number;
  targetSolutionKWh: number;
  onTargetChange: (value: number) => void;
}

export const SolutionSettingsCard: React.FC<SolutionSettingsCardProps> = ({
  contractedCapacity,
  targetSolutionKWh,
  onTargetChange,
}) => {
  const threshold = (24 * contractedCapacity) + targetSolutionKWh;

  const formatKWh = (value: number) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(1)} MWh`;
    }
    return `${Math.round(value)} kWh`;
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Settings className="h-4 w-4" />
          Beoogde Oplossing Instellingen
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-muted-foreground" />
              Contractvermogen
            </Label>
            <div className="flex items-center gap-2">
              <Input
                type="number"
                value={contractedCapacity}
                disabled
                className="bg-muted"
              />
              <span className="text-sm text-muted-foreground whitespace-nowrap">kWp (uit analyse)</span>
            </div>
          </div>
          
          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <Battery className="h-4 w-4 text-muted-foreground" />
              Batterij/Extra kWh
            </Label>
            <div className="flex items-center gap-2">
              <Input
                type="number"
                value={targetSolutionKWh}
                onChange={(e) => onTargetChange(parseInt(e.target.value) || 0)}
                min={0}
                step={100}
                placeholder="0"
              />
              <span className="text-sm text-muted-foreground whitespace-nowrap">kWh</span>
            </div>
          </div>
        </div>

        <Separator />

        <div className="bg-muted/50 rounded-lg p-4 space-y-2">
          <div className="flex justify-between items-center">
            <span className="text-sm font-medium">Dag Threshold:</span>
            <span className="text-lg font-bold">{formatKWh(threshold)}</span>
          </div>
          <div className="flex justify-between items-center text-sm text-muted-foreground">
            <span>Formule:</span>
            <span>24u × {contractedCapacity} kWp + {targetSolutionKWh.toLocaleString()} kWh</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SolutionSettingsCard;
